import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TeeSectionHeader from '@/components/ui/tee-section-header';
import { ContentCardGrid } from './ContentCardGrid';
import { AttachToPlayerModal } from './AttachToPlayerModal';
import { ContentItem } from '@/types/contentItem';

export function ResourceFinderPage() {
  const { t } = useTranslation();
  const [attachItem, setAttachItem] = useState<ContentItem | null>(null);

  return (
    <div className="section_container">
      <TeeSectionHeader
        title={t('contentLibrary.resourceFinderTitle')}
        description={t('contentLibrary.resourceFinderSubtitle')}
      />
      <div className="section_body">
        <ContentCardGrid onAttach={setAttachItem} />
      </div>
      <AttachToPlayerModal
        isOpen={attachItem !== null}
        item={attachItem}
        onClose={() => setAttachItem(null)}
      />
    </div>
  );
}

export default ResourceFinderPage;
